import GradBoy3D from '../assets/avatars/3d_student_grad_boy.png';
import GirlTablet3D from '../assets/avatars/3d_student_girl_tablet.png';
import FormalMale3D from '../assets/avatars/3d_formal_male.png';
import FormalFemale3D from '../assets/avatars/3d_formal_female.png';
import ChessKing3D from '../assets/avatars/3d_chess_king.png';
import ChessQueen3D from '../assets/avatars/3d_chess_queen.png';
import Leo3D from '../assets/3d_icons/companion_leo.png';
import Sparky3D from '../assets/3d_icons/companion_sparky.png';
import Merlin3D from '../assets/3d_icons/companion_merlin.png';
import Rocky3D from '../assets/3d_icons/companion_rocky.png';
import Knight3D from '../assets/3d_icons/icon_knight.png';
import Pawn3D from '../assets/3d_icons/icon_pawn.png';

export const AVATAR_CATEGORIES = [
    {
        id: 'students',
        label: '🎓 3D Students',
        description: '3D Scholars & Students with caps, tablets, & glasses',
        avatars: [
            { id: 'grad_boy_3d', name: '3D Scholar Boy', url: GradBoy3D, badge: 'GRADUATE' },
            { id: 'girl_tablet_3d', name: '3D Smart Girl', url: GirlTablet3D, badge: 'STUDENT' },
            { id: 'student_chibi_1', name: 'Chibi Scholar Felix', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Felix&backgroundColor=transparent' },
            { id: 'student_chibi_2', name: 'Chibi Scholar Maya', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Maya&backgroundColor=transparent' },
            { id: 'student_3d_1', name: '3D Student Leo', url: 'https://api.dicebear.com/9.x/micah/svg?seed=StudentLeo&backgroundColor=transparent' },
            { id: 'student_3d_2', name: '3D Student Sophia', url: 'https://api.dicebear.com/9.x/micah/svg?seed=StudentSophia&backgroundColor=transparent' },
            { id: 'student_3d_3', name: '3D Student Rohan', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Rohan&backgroundColor=transparent' },
            { id: 'student_3d_4', name: '3D Student Ananya', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Ananya&backgroundColor=transparent' }
        ]
    },
    {
        id: 'formals',
        label: '👔 Formals & Standard',
        description: 'Formal corporate, executive, & coach avatars',
        avatars: [
            { id: 'formal_male_3d', name: '3D Executive Male', url: FormalMale3D, badge: 'COACH' },
            { id: 'formal_female_3d', name: '3D Executive Female', url: FormalFemale3D, badge: 'COACH' },
            { id: 'formal_2d_1', name: 'Formal Professional Arthur', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Arthur&style=circle' },
            { id: 'formal_2d_2', name: 'Formal Professional Elena', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Elena&style=circle' },
            { id: 'formal_2d_3', name: 'Classic Coach Alexander', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Alexander&style=circle' },
            { id: 'formal_2d_4', name: 'Classic Coach Victoria', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Victoria&style=circle' },
            { id: 'formal_notion_1', name: 'Notionist Master', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Grandmaster' },
            { id: 'formal_notion_2', name: 'Notionist Mentor', url: 'https://api.dicebear.com/9.x/notionists/svg?seed=Mentor' }
        ]
    },
    {
        id: 'humanize',
        label: '🧑 Humanize (2D)',
        description: 'Friendly illustrated vector portraits & diverse people',
        avatars: [
            { id: 'human_1', name: 'Aarav', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Aarav' },
            { id: 'human_2', name: 'Diya', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Diya' },
            { id: 'human_3', name: 'Kabir', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Kabir' },
            { id: 'human_4', name: 'Sanya', url: 'https://api.dicebear.com/9.x/avataaars/svg?seed=Sanya' },
            { id: 'human_5', name: 'Lucas', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Lucas' },
            { id: 'human_6', name: 'Emma', url: 'https://api.dicebear.com/9.x/open-peeps/svg?seed=Emma' },
            { id: 'human_7', name: 'Zane', url: 'https://api.dicebear.com/9.x/lorelei/svg?seed=Zane' },
            { id: 'human_8', name: 'Chloe', url: 'https://api.dicebear.com/9.x/lorelei/svg?seed=Chloe' }
        ]
    },
    {
        id: 'memoji3d',
        label: '🤖 3D Memojis',
        description: 'Soft 3D styled Memojis with infinite variations',
        isGenerative: true,
        styleId: 'micah',
        avatars: [
            { id: 'memoji_1', name: '3D Felix', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Felix&backgroundColor=transparent' },
            { id: 'memoji_2', name: '3D Aneka', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Aneka&backgroundColor=transparent' },
            { id: 'memoji_3', name: '3D Liam', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Liam&backgroundColor=transparent' },
            { id: 'memoji_4', name: '3D Sophia', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Sophia&backgroundColor=transparent' },
            { id: 'memoji_5', name: '3D Noah', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Noah&backgroundColor=transparent' },
            { id: 'memoji_6', name: '3D Olivia', url: 'https://api.dicebear.com/9.x/micah/svg?seed=Olivia&backgroundColor=transparent' }
        ]
    },
    {
        id: 'animals',
        label: '🐶 Animals & Companions',
        description: 'Cute 3D pets, lions, owls, foxes, & fantasy creatures',
        avatars: [
            { id: 'anim_leo', name: 'Leo the Lion (3D)', url: Leo3D },
            { id: 'anim_sparky', name: 'Sparky the Fox (3D)', url: Sparky3D },
            { id: 'anim_merlin', name: 'Merlin the Owl (3D)', url: Merlin3D },
            { id: 'anim_rocky', name: 'Rocky the Bear (3D)', url: Rocky3D },
            { id: 'noto_fox', name: '3D Cute Fox', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f98a/512.webp' },
            { id: 'noto_panda', name: '3D Panda Bear', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f43c/512.webp' },
            { id: 'noto_unicorn', name: '3D Magical Unicorn', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f984/512.webp' },
            { id: 'noto_trex', name: '3D T-Rex Dino', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f996/512.webp' }
        ]
    },
    {
        id: 'cartoonish',
        label: '🎨 Cartoonish & Chibi',
        description: 'Fun RPG adventurers, anime chibi, & playful emojis',
        isGenerative: true,
        styleId: 'adventurer',
        avatars: [
            { id: 'cart_1', name: 'Adventurer Jack', url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Jack&backgroundColor=transparent' },
            { id: 'cart_2', name: 'Adventurer Mia', url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Mia&backgroundColor=transparent' },
            { id: 'cart_3', name: 'Chibi Oliver', url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Oliver&backgroundColor=transparent' },
            { id: 'cart_4', name: 'Chibi Amelia', url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Amelia&backgroundColor=transparent' },
            { id: 'emoji_1', name: 'Happy Emoji', url: 'https://api.dicebear.com/9.x/fun-emoji/svg?seed=Happy&backgroundColor=transparent' },
            { id: 'emoji_2', name: 'Cool Glasses Emoji', url: 'https://api.dicebear.com/9.x/fun-emoji/svg?seed=Cool&backgroundColor=transparent' },
            { id: 'emoji_3', name: 'Star Eyes Emoji', url: 'https://api.dicebear.com/9.x/fun-emoji/svg?seed=Stars&backgroundColor=transparent' }
        ]
    },
    {
        id: 'objects',
        label: '⚡ 3D Objects & Chess',
        description: '3D Chess Kings, Queens, Pawns, Trophies, Rockets & Props',
        avatars: [
            { id: 'obj_king', name: 'Golden Chess King 3D', url: ChessKing3D },
            { id: 'obj_queen', name: 'Royal Chess Queen 3D', url: ChessQueen3D },
            { id: 'obj_knight', name: 'Knight Warrior 3D', url: Knight3D },
            { id: 'obj_pawn', name: 'Champion Pawn 3D', url: Pawn3D },
            { id: 'noto_fire', name: '3D Fire Flare', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f525/512.webp' },
            { id: 'noto_rocket', name: '3D Cosmic Rocket', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f680/512.webp' },
            { id: 'noto_ufo', name: '3D UFO Spaceship', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f6f8/512.webp' },
            { id: 'noto_robot', name: '3D Mecha Bot', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f916/512.webp' },
            { id: 'noto_ghost', name: '3D Ghost', url: 'https://fonts.gstatic.com/s/e/notoemoji/latest/1f47b/512.webp' }
        ]
    }
];

export function isValidAvatarUrl(url) {
    if (!url || typeof url !== 'string') return false;
    const trimmed = url.trim();
    return (
        trimmed.startsWith('http://') ||
        trimmed.startsWith('https://') ||
        trimmed.startsWith('/') ||
        trimmed.startsWith('data:') ||
        trimmed.startsWith('blob:') ||
        trimmed.startsWith('static/')
    );
}

export function getDefaultAvatar(nameOrEmail = 'User') {
    const seed = encodeURIComponent(nameOrEmail.split('@')[0] || 'User');
    return `https://api.dicebear.com/9.x/micah/svg?seed=${seed}&backgroundColor=transparent`;
}
